/**
 * InThisBlueprint — chapter-opener card at the top of every read.
 *
 * Editorial treatment: white card, single warm hairline border, a thin crimson
 * top rule and a small crimson kicker label, CheckList of section teasers.
 * (Reworked from the 3px navy border + 8px coral stripe + Archivo Black header
 * "Dummies" signature.)
 */

import CheckList from "./lists/CheckList.jsx";

export default function InThisBlueprint({ items, headerLabel = "In this read" }) {
  return (
    <div
      style={{
        background: "var(--ppr-color-background-surface)",
        border: "1px solid var(--ppr-color-border-default)",
        borderTop: "2px solid var(--ppr-color-accent-coral)",
        padding: "20px 24px 18px",
        marginBottom: 32,
      }}
      data-component="InThisBlueprint"
    >
      <div
        style={{
          fontFamily: "var(--ppr-typography-font-family-ui)",
          fontSize: "11px",
          letterSpacing: "0.16em",
          textTransform: "uppercase",
          color: "var(--ppr-color-accent-coral)",
          marginBottom: 8,
        }}
      >
        {headerLabel}
      </div>
      <CheckList items={items} />
    </div>
  );
}
